import React, { Component } from "react";
import { PieGraph } from "../../../../common/graph/pie-chart.component";
import { ChartHeaderDropdown } from "../../../../common/data-header/chart-header-dropdown.component";
const graphData = [ 
    {name: 'Wireless', value:915, fill:"#008eff"},
    {name: 'Wireline', value:37, fill:"#ffc82c"},
    {name: 'HOC', value:9, fill:"#d5002f"}
];
const  barData = [{name: 'Wireless', color:'#008eff'}, 
{name: 'Wireline', color:'#ffc82c'}, 
{name: 'HOC', color:'#d5002f'}, 
{name: 'Others', color:'#919eab'}];

export class CostDistribution extends Component {
    render() {
        return(
           <div className="cost-report-summary-wrapper">            
               <ChartHeaderDropdown haveOneIcone={true} haveIconInfo={true} iconInfo="info-circle-solid" haveLedger={true} ledger={barData} headerName="Cost Distribution per Service Type" circleIcon={false} circleFirstIcon="list-regular" circleSecondIcon="th-solid" oneIcon="vertical-grid" 
                   haveInput={false} haveDropdown={false}  /> 
                <PieGraph data={graphData} displayLegend={true} />     
           </div>
        );
    }
}